import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../../Contexts/ProductContext";
import { WishlistCard } from "../../Component/WishlistCard/WishlistCard";
import "./WishlistStyle.css";
import { getWishlistProduct } from "../../Utils/wishlistUtils";
import { AuthContext } from "../../Contexts/AuthContext";

const Wishlist = () => {
  const { authState, setLoader } = useContext(AuthContext);
  const { productState, productDispatch } = useContext(ProductContext);
  const { wishlistIds, wishlist } = productState;
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleAsyncGetWhislistCard = async () => {
      setLoader(true);
      const whisListDataResponse = await getWishlistProduct(authState?.mobile);
      if (whisListDataResponse !== null) {
        productDispatch({ type: "setWishlist", payload: whisListDataResponse });
      }
      setLoader(false);
    }

    if (wishlistIds !== null && wishlistIds.length > 0) {
      handleAsyncGetWhislistCard();
    }
  }, [wishlistIds, authState?.mobile])

  return (
    <>
      {wishlist?.length === 0 ? (
        <div className="empty-wishlist">
          <h1>Your Wishlist is Empty!🙁</h1>
          <p>Start exploring Watches and add your favourites to Wishlist.</p>
          <button onClick={() => navigate("/products")}>Explore Watches</button>
        </div>
      ) : (
        <div className="wishlist-container">
          <h1 className="wishlist-heading">Wishlist ({wishlist?.length})</h1>
          <div className="wishlist-card-container">
            {wishlist.map((product) => (
              <WishlistCard key={product?.prdId} product={product} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
export { Wishlist };
